var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert row row--light"},[_c('icon',{attrs:{"icon-name":"alert-circle","view-box":"0 0 24 24"}}),_vm._v(" "),_c('p',{staticClass:"alert--text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }